// Libs
import Vue from 'vue'
import Router from 'vue-router'
// Main Components
import TrainingList from '@/components/TrainingList'
import WorkoutList from '@/components/WorkoutList'
// Settings Components
import EatingPlan from '@/components/Settings/EatingPlan'
import Profile from '@/components/Settings/Profile'
import PaymentConfirm from '@/components/Settings/PaymentConfirm'
import ReciptFind from '@/components/Settings/ReciptFind'
import Statisitc from '@/components/Settings/Statisitc'
import Training from '@/components/Settings/TrainingMen'
import TrainingFlow from '@/components/Settings/TrainingFlow'
import TrainingEnd from '@/components/Settings/TrainingEnd'
import TrainingRedirect from '@/components/Settings/TrainingRedirect'
// Pages
import PaymentError from '@/components/Pages/PaymentError'
// LangKyfuage Specific
import Home from '@/components/LangKyf/TH/Home'
import Help from '@/components/LangKyf/TH/Help'
import Deactivation from '@/components/LangKyf/TH/Deactivation'
import Imprint from '@/components/LangKyf/TH/Imprint'
import Terms from '@/components/LangKyf/TH/Terms'
import LP from '@/components/LangKyf/TH/LP'
import LP2 from '@/components/LangKyf/TH/LP2'
import CreateProfile from '@/components/LangKyf/TH/CreateProfile'




Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/create-profile',
            name: 'CreateProfile',
            component: CreateProfile
        },
        {
            path: '/help',
            name: 'Help',
            component: Help
        },
        {
            path: '/deactivation',
            name: 'Deactivation',
            component: Deactivation
        },
        {
            path: '/imprint',
            name: 'Imprint',
            component: Imprint
        },
        {
            path: '/terms-and-conditions',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/eating-plan',
            name: 'EatingPlan',
            component: EatingPlan
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/recipt-find',
            name: 'ReciptFind',
            component: ReciptFind
        },
        {
            path: '/lp',
            name: 'LP',
            component: LP
        },
        {
            path: '/man-and-woman',
            name: 'LP2',
            component: LP2
        },
        {
            path: '/statisitc',
            name: 'Statisitc',
            component: Statisitc
        },
        {
            path: '/training',
            name: 'Training',
            component: Training
        },
        {
            path: '/training-program',
            name: 'TrainingFlow',
            component: TrainingFlow
        },
        {
            path: '/training-end',
            name: 'TrainingEnd',
            component: TrainingEnd
        },
        {
            path: '/payment-confirmation',
            name: 'PaymentConfirm',
            component: PaymentConfirm
        },
        {
            path: '/payment-error',
            name: 'PaymentError',
            component: PaymentError
        },
        {
            path: '/training-list',
            name: 'TrainingList',
            component: TrainingList
        },
        {
            path: '/training/:name',
            name: 'TrainingSpecial',
            component: TrainingRedirect,
        },
        {
            path: '/workout-list',
            name: 'WorkoutList',
            component: WorkoutList
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/kyf/th.js